import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core'
import { fromEvent, Subscription } from 'rxjs'
import { filter } from 'rxjs/operators'

@Directive({
  selector: '[jmlClickOutside]'
})
// clickOutside callback function triggers once the user clicks outside of the assigned component
export class ClickOutsideDirective implements AfterViewInit, OnDestroy {
  @Output() clickOutside = new EventEmitter()

  clickSubscription: Subscription

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const clickOutside$ = fromEvent(document, 'click').pipe(
      filter(({ target }) => !this.el.nativeElement.contains(target))
    )

    this.clickSubscription = clickOutside$.subscribe((event) => {
      this.clickOutside.emit(event)
    })
  }

  ngOnDestroy(): void {
    this.clickSubscription?.unsubscribe()
  }
}
